import { render, staticRenderFns } from "./post_offer.vue?vue&type=template&id=f8af5848&scoped=true&"
import script from "./post_offer.vue?vue&type=script&lang=js&"
export * from "./post_offer.vue?vue&type=script&lang=js&"
import style0 from "./post_offer.vue?vue&type=style&index=0&id=f8af5848&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8af5848",
  null
  
)

export default component.exports